import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon20 } from 'builder/components/Icon'

export const Icon = styled(Icon20.ChevronRightRegular)`
  display: none;
  color: ${Colors.Blue60};
`

export const Button = styled.a`
  ${Typography.ButtonS}
  ${FontWeights.Medium}

  cursor: pointer;
  color: ${Colors.Blue50};
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S};
  padding: ${Spacing.L};
  width: 100%;
  background-color: ${Colors.Blue10};
  border-radius: ${Spacing['2XS']};

  &:hover {
    background-color: ${Colors.Blue20};

    ${Icon} {
      display: block;
    }

    ${Button} {
      color: ${Colors.Blue60};
    }
  }
`

export const ImageWrapper = styled.aside`
  width: 98px;
  height: 72px;
`

export const DetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S};
  width: 100%;
  justify-content: space-between;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  color: ${Colors.Blue80};
`

export const Title = styled.span`
  ${Typography.Body};
  ${FontWeights.DemiBold};
`

export const SubTitle = styled.span`
  ${Typography.Caption};
  ${FontWeights.Regular};
`

export const ButtonWrapper = styled.div`
  min-width: 130px;
  display: flex;
`

export const LocationPin = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const TargetLocationImage = styled.img`
  width: 273.46px;
  height: 158.22px;
  margin-bottom: 36px;
  object-fit: contain;
`
